import { render, staticRenderFns } from "./areaTj.vue?vue&type=template&id=594b629d&scoped=true&"
import script from "./areaTj.vue?vue&type=script&lang=js&"
export * from "./areaTj.vue?vue&type=script&lang=js&"
import style0 from "./areaTj.vue?vue&type=style&index=0&id=594b629d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b629d",
  null
  
)

export default component.exports